import TicketSaleService from './../services/ticket-sale.service'
import { busSeatSelectionConstants } from '../constants/bus-seat-selection.constants'
import { toastActions } from '@actions'
import { Creators as TicketSaleCreators } from '../ducks/ticket-sale/ticket-sale'
import { mapSeatCells } from '../helpers/seat-map.helper'

const loadBusSeatsGoing = (params) => async (dispatch) => {
	const { data, success, message } = await TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		// Spec 055 (T087): sem a mensagem do Hub (rede, gateway) o erro sai vazio e quem chama usa o texto padrão -
		// `new Error(null)` viraria o aviso "null".
		throw new Error(message || '')
	} else {
		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(
			TicketSaleCreators.setExtraDataGoing({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
				// Seguro só nas pernas que o oferecem (gateway RODOSOFT - decidido pelo MuviHub).
				insuranceOffered: !!data.isInsuranceOffered,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	}
}

const loadBusSeatsGoingConexao = (params) => async (dispatch) => {
	// trips/seat-map returns the same { layout, terminals, priceBreakdown }
	// shape regardless of kind - a leg of a connection isn't any different
	// from a direct trip's single leg.
	const { data, success, message } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_GOING
	)

	if (!success) {
		// Spec 055 (T087): sem a mensagem do Hub (rede, gateway) o erro sai vazio e quem chama usa o texto padrão -
		// `new Error(null)` viraria o aviso "null".
		throw new Error(message || '')
	} else {
		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_GOING,
		})

		dispatch(
			TicketSaleCreators.setExtraDataGoing({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
				// Seguro só nas pernas que o oferecem (gateway RODOSOFT - decidido pelo MuviHub).
				insuranceOffered: !!data.isInsuranceOffered,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationGoing({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	}
}

const loadBusSeatsReturnConexao = (params) => async (dispatch) => {
	const { data, success, message } = await TicketSaleService.getBusData(
		{
			...params,
			busCompany: params.enterprise,
		},
		busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN
	)

	if (!success || !data) {
		dispatch(
			toastActions.danger({
				message:
					message ||
					'Não foi possível obter as poltronas, tente novamente mais tarde.',
			})
		)
		return false
	}

	const busSeats = mapSeatCells(data.layout)

	dispatch({
		payload: busSeats,
		type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
	})

	dispatch(
		TicketSaleCreators.setExtraDataReturn({
			tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
			fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
			toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
			insurance: data.priceInsuranceAmount || 0,
			// Seguro só nas pernas que o oferecem (gateway RODOSOFT - decidido pelo MuviHub).
			insuranceOffered: !!data.isInsuranceOffered,
		})
	)

	dispatch(
		TicketSaleCreators.setTripEmbarcationReturn({
			boardingTerminal: data.terminals.boarding,
			disembarkingTerminal: data.terminals.disembarking,
		})
	)
}

const loadBusSeatsReturn = (params) => (dispatch) => {
	return TicketSaleService.getBusData(
		params,
		busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN
	).then(({ data, success, message }) => {
		if (!success || !data) {
			dispatch(
				toastActions.danger({
					message:
						message ||
						'Não foi possível obter as poltronas, tente novamente mais tarde.',
				})
			)
			return false
		}

		const busSeats = mapSeatCells(data.layout)

		dispatch({
			payload: busSeats,
			type: busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN,
		})

		dispatch(
			TicketSaleCreators.setExtraDataReturn({
				tax: (data.priceBreakdown && data.priceBreakdown.boardingTax) || 0,
				fee: (data.priceBreakdown && data.priceBreakdown.serviceCharge) || 0,
				toll: (data.priceBreakdown && data.priceBreakdown.toll) || 0,
				insurance: data.priceInsuranceAmount || 0,
				// Seguro só nas pernas que o oferecem (gateway RODOSOFT - decidido pelo MuviHub).
				insuranceOffered: !!data.isInsuranceOffered,
			})
		)

		dispatch(
			TicketSaleCreators.setTripEmbarcationReturn({
				boardingTerminal: data.terminals.boarding,
				disembarkingTerminal: data.terminals.disembarking,
			})
		)
	})
}

const selectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_GOING,
	})
	dispatch(TicketSaleCreators.setPriceGoing(payload.price))
}

const deselectBusSeatGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_GOING,
	})
}

const selectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SELECT_BUS_SEAT_RETURN,
	})
	dispatch(TicketSaleCreators.setPriceReturn(payload.price))
}
const deselectBusSeatReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.DESELECT_BUS_SEAT_RETURN,
	})
}

const setTotalSeatsGoing = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_GOING,
	})
}

const setOrdemViagemIda = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_ORDEM_VIAGEM_IDA,
	})
}

const getOrdemViagemIda = () => ({
	type: busSeatSelectionConstants.GET_ORDEM_VIAGEM_IDA,
})

const setTotalSeatsReturn = (payload) => (dispatch) => {
	dispatch({
		payload,
		type: busSeatSelectionConstants.SET_TOTAL_SEATS_RETURN,
	})
}

const reset = () => ({
	type: busSeatSelectionConstants.RESET,
})

/**
 * Merges partial data into seats already booked, matched by reservation
 * @param {Object<string, object>} payload Partial seat data keyed by transactionId
 */
const updateSelectedSeats = (payload) => ({
	payload,
	type: busSeatSelectionConstants.UPDATE_SELECTED_SEATS,
})

const getNumberOfPassengers = () => ({
	type: busSeatSelectionConstants.GET_NUMBER_OF_PASSENGERS,
})

export const busSeatSelectionActions = {
	reset,
	updateSelectedSeats,
	loadBusSeatsGoing,
	loadBusSeatsReturn,
	loadBusSeatsGoingConexao,
	loadBusSeatsReturnConexao,
	selectBusSeatGoing,
	setTotalSeatsGoing,
	selectBusSeatReturn,
	setTotalSeatsReturn,
	deselectBusSeatGoing,
	deselectBusSeatReturn,
	getNumberOfPassengers,
	setOrdemViagemIda,
	getOrdemViagemIda,
}
